import React from 'react';
import {User} from '../../models/user/User';
import {backendUrl, isDev} from '../../utils';
import OldUrls from '../../models/utils/OldUrls';
import Account from '../../models/account/Account';

type HelpScoutBeaconProps = {
  account: Account
  user: User
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-shadow,@typescript-eslint/no-empty-function
!function(e,t,n){function a(){const e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
if (isDev()) {
  (window as any).Beacon('init', '50c6176b-8ad5-4c77-8ff7-1b3007d3578c');
} else {
  (window as any).Beacon('init', 'd16e5cf4-48d9-4fd3-80bf-bbc939095ec1');
}

export default function HelpScoutBeacon({account, user}: HelpScoutBeaconProps) {
  (window as any).Beacon('identify', {
    userId: user.id,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    accountId: account.id,
    accountName: account.name,
    accountType: account.readableType(),
    accountSwitch: backendUrl(OldUrls.switchAccount(account.id))
  });
  return (<></>);
}
